var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnFolios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4971 14.9295V10.4593C16.4971 9.85172 16.4971 9.28753 16.5407 9.24413C16.5407 9.20073 16.4971 8.59313 16.4971 7.98554V1.43219C16.4971 0.824598 15.9748 0.303802 15.3654 0.303802H1.43642C0.827024 0.303802 0.304688 0.824598 0.304688 1.43219V8.20254C0.304688 8.81013 0.304688 9.80832 0.304688 10.4159V19.66C0.304688 20.2676 0.304688 20.962 0.304688 21.2224C0.304688 21.4828 0.304688 21.7432 0.304688 21.7866C0.304688 21.83 0.652912 22.264 1.00114 22.7414C1.34936 23.1754 1.69759 23.6094 1.78464 23.6528C1.78464 23.6528 1.78464 23.6528 1.8717 23.6528C1.95875 23.6528 1.95875 23.6528 1.95875 23.6528C2.04581 23.6094 2.43756 23.1754 2.87284 22.698L3.48224 22.1338C3.87399 21.6564 4.52691 21.6998 4.91866 22.1772L5.35394 22.698C5.7457 23.1754 6.09392 23.6094 6.13745 23.6094C6.18098 23.6528 6.35509 23.6528 6.39862 23.6528C6.44215 23.6528 6.87743 23.1754 7.26918 22.698L7.70446 22.1772C8.09621 21.6998 8.7056 21.6998 9.09736 22.1772L9.48911 22.6546C9.88086 23.132 10.2291 23.566 10.3161 23.6528C10.3161 23.6528 10.3161 23.6528 10.4032 23.6528C10.4903 23.6528 10.4903 23.6528 10.4903 23.6528C10.5773 23.566 10.9691 23.1754 11.3608 22.698L11.8832 22.0904C12.2749 21.613 12.9278 21.613 13.3196 22.0904L13.8419 22.698C14.2337 23.1754 14.6254 23.566 14.6689 23.6094C14.7125 23.6528 14.8431 23.6528 14.8431 23.6528C14.8431 23.6528 14.8866 23.6528 14.9301 23.6528C14.9736 23.6528 15.4089 23.1754 15.7572 22.7414C16.1489 22.3074 16.4101 21.9168 16.4101 21.9168",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00342 5.72876H3.61281",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70215 5.72876H13.8419",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00342 7.85535H3.61281",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70215 7.85535H13.8419",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00342 10.0253H3.61281",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70215 10.0253H13.8419",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00342 13.4539H3.61281",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8396 13.4539H13.8419",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8396 14.9295H13.8419",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8396 16.4051H13.8419",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.348145 2.03979H16.4971",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13866 17.4466C7.13866 17.4466 7.31277 18.2278 8.13981 18.1844C8.79273 18.1844 9.27154 17.7504 9.27154 17.1862C9.27154 16.6221 9.0539 16.0145 8.22686 16.0145C7.53041 16.0145 7.00808 15.6673 7.05161 14.8427C7.09513 14.0615 7.74806 13.9313 8.13981 13.9313C8.61862 13.9313 9.09743 14.1917 9.14095 14.7993",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09619 13V13.9982",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09619 19.226V18.1844",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8889,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFolios);
export default __webpack_public_path__ + "static/media/icn-folios.7826b111.svg";
export { ForwardRef as ReactComponent };